import { useEffect, useState } from "react";
import api from "services/api";
import NAVBAR from "components/navbar";
import config from "config";
import './style.css';
import { formatDate } from "components/formatos";

function LISTAEXTRATO() {
    const [lnotas, setlNotas] = useState([]);
    const [searchTerm, setSearchTerm] = useState(""); // Estado para o termo de busca
    const [filteredNotas, setFilteredNotas] = useState([]); // Estado para a lista filtrada

    useEffect(() => {
        // Busca Participantes
        api.get(config.EXTRATO)
            .then(response => {
                setlNotas(response.data);
                setFilteredNotas(response.data); // Inicializa a lista filtrada
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        // Filtra os participantes com base no termo de busca
        setFilteredNotas(
            lnotas.filter(lista =>
                lista.nomeestabelecimento.toLowerCase().includes(searchTerm.toLowerCase())
            )
        );
    }, [searchTerm, lnotas]);

    return (
        <div className="container-fluid mt-page">
            <NAVBAR />
            <div>
                <h1>Extrato de Lançamentos</h1>
                <div className="mb-3">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Buscar por nome do estabelecimento..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)} // Atualiza o termo de busca
                    />
                </div>
                <div className="row">
                    {filteredNotas.map((d) => {
                        return (
                            <div key={`venda${d.id_venda}`} className="col-12 col-sm-6 col-md-4 p-2">
                                <div className="card">
                                    <div className="card-body">
                                        <h5 className="card-title">{d.nomeestabelecimento}</h5>
                                        <p className="card-text">Data da Venda: {formatDate(d.dat_venda)}</p>
                                        <p className="card-text">Valor da Venda: R$ {d.valor_venda.toFixed(2)}</p>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

export default LISTAEXTRATO;
